import { useEffect } from 'react'
import MainHeader from '../../components/MainHeader'
import Programs from '../../components/Programs'
import About from '../../components/About'
import Testimonials from '../../components/Testimonials'
import './home.css'

const Home = () => {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <MainHeader />
      <Programs />
      <About />
      <Testimonials />
    </>
  )
}

export default Home
